'use strict';

module Patersons {

    export class feedListComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/research/components/feedList.component.html';
        controller: any = FeedListController;
        bindings: any = {
            feedItems: '<',
            title: '@'
        };
    }

    export class FeedListController {
        feedItems: Array<Feed>;
        predicate: string;
        reverse: boolean;

        constructor() {
            this.predicate = 'publishedDate';
            this.reverse = true;
        }

        order(predicate: string) {
            this.reverse = (this.predicate === predicate) ? !this.reverse : false;
            this.predicate = predicate;
        }
    }
}
